export default function CakeIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.33337 15.166H14.6667" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M2.07336 15.166V9.16602C2.07336 8.05935 3.0667 7.16602 4.29336 7.16602H11.7C12.9267 7.16602 13.92 8.05935 13.92 9.16602V15.166"
        strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M3.70667 7.16732V5.28065C3.70667 4.48065 4.42667 3.83398 5.32 3.83398H10.6867C11.5733 3.83398 12.2933 4.48065 12.2933 5.28065V7.16732"
        strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M2.35339 9.82031L2.60006 9.82698C3.09339 9.83365 3.48673 10.2336 3.48673 10.727V10.947C3.48673 11.4403 3.88673 11.847 4.38673 11.847C4.88006 11.847 5.28673 11.447 5.28673 10.947V10.7403C5.28673 10.247 5.68673 9.84031 6.18673 9.84031C6.68006 9.84031 7.08673 10.2403 7.08673 10.7403V10.947C7.08673 11.4403 7.48673 11.847 7.98673 11.847C8.48006 11.847 8.88673 11.447 8.88673 10.947V10.7403C8.88673 10.247 9.28673 9.84031 9.78673 9.84031C10.2801 9.84031 10.6867 10.2403 10.6867 10.7403V10.947C10.6867 11.4403 11.0867 11.847 11.5867 11.847C12.0801 11.847 12.4867 11.447 12.4867 10.947V10.7403C12.4867 10.247 12.8867 9.84031 13.3867 9.84031H13.6867"
        strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.33337 3.83333V2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.6666 3.83333V2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 3.83398V1.83398" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
